/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WorkingDayTime } from './WorkingDayTime';
import {
    WorkingDayTimeFromJSON,
    WorkingDayTimeFromJSONTyped,
    WorkingDayTimeToJSON,
} from './WorkingDayTime';

/**
 * 
 * @export
 * @interface ClinicModify
 */
export interface ClinicModify {
    /**
     * 
     * @type {string}
     * @memberof ClinicModify
     */
    name: string;
    /**
     * icon filename+ext
     * @type {string}
     * @memberof ClinicModify
     */
    avatarName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClinicModify
     */
    images: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClinicModify
     */
    specialistIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClinicModify
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof ClinicModify
     */
    shiftDuration?: number;
    /**
     * 
     * @type {string}
     * @memberof ClinicModify
     */
    type: ClinicModifyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ClinicModify
     */
    introduction?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicModify
     */
    bookingMessage?: string;
    /**
     * 
     * @type {Array<WorkingDayTime>}
     * @memberof ClinicModify
     */
    workingPlan?: Array<WorkingDayTime>;
    /**
     * 
     * @type {boolean}
     * @memberof ClinicModify
     */
    hidden?: boolean;
}


/**
 * @export
 */
export const ClinicModifyTypeEnum = {
    Clinic: 'CLINIC',
    Hospital: 'HOSPITAL'
} as const;
export type ClinicModifyTypeEnum = typeof ClinicModifyTypeEnum[keyof typeof ClinicModifyTypeEnum];


/**
 * Check if a given object implements the ClinicModify interface.
 */
export function instanceOfClinicModify(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "avatarName" in value;
    isInstance = isInstance && "images" in value;
    isInstance = isInstance && "specialistIds" in value;
    isInstance = isInstance && "address" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function ClinicModifyFromJSON(json: any): ClinicModify {
    return ClinicModifyFromJSONTyped(json, false);
}

export function ClinicModifyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClinicModify {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'avatarName': json['avatarName'],
        'images': json['images'],
        'specialistIds': json['specialistIds'],
        'address': json['address'],
        'shiftDuration': !exists(json, 'shiftDuration') ? undefined : json['shiftDuration'],
        'type': json['type'],
        'introduction': !exists(json, 'introduction') ? undefined : json['introduction'],
        'bookingMessage': !exists(json, 'bookingMessage') ? undefined : json['bookingMessage'],
        'workingPlan': !exists(json, 'workingPlan') ? undefined : ((json['workingPlan'] as Array<any>).map(WorkingDayTimeFromJSON)),
        'hidden': !exists(json, 'hidden') ? undefined : json['hidden'],
    };
}

export function ClinicModifyToJSON(value?: ClinicModify | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'avatarName': value.avatarName,
        'images': value.images,
        'specialistIds': value.specialistIds,
        'address': value.address,
        'shiftDuration': value.shiftDuration,
        'type': value.type,
        'introduction': value.introduction,
        'bookingMessage': value.bookingMessage,
        'workingPlan': value.workingPlan === undefined ? undefined : ((value.workingPlan as Array<any>).map(WorkingDayTimeToJSON)),
        'hidden': value.hidden,
    };
}

